import styled from 'styled-components';

export const MenuIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 48px;
  height: 48px;
  margin-top: 24px;
  margin-bottom: 32px;

  svg {
    left: 0px;
    g:first-child {
      circle {
        opacity: 0 !important;
      }
    }
  }
`;
export const MenuIconImageContainer = styled.button`
  display: flex;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
`;

export const MenuCenterIcon = styled.span`
  color: white;
  font-size: 16px;
  margin-top: 7px;
`;
